function urlSearchParamsToObject(urlSearchParam) {
  const entries = urlSearchParam.entries();
  let result = {};
  for (let entry of entries) {
    // each 'entry' is a [key, value] tupple
    const [key, value] = entry;
    result[key] = value;
  }
  return result;
}

export default urlSearchParamsToObject;
